module.exports = __webpack_public_path__ + "img/TvDip-logo_small_dark.d63bcf.png";